import { IAPIUserHr, IHRPermissions, IUserHr } from '../interfaces/IUserHr'

class Transformer {
  static transform(data: IAPIUserHr): IUserHr {
    const permissions: IHRPermissions = {
      hasAccessToSettings: data.permissions.has_access_to_settings,
      isVisibleInCalendar: data.permissions.is_visible_in_calendar,
      isVisibleOnline: data.permissions.is_visible_online,
      settingsAccountManage: data.permissions['settings.account.manage'],
      hrUsersManage: data.permissions['hr.users.manage'],
      hrAbsencesManage: data.permissions['hr.absences.manage'],
      hrPunchClockManage: data.permissions['hr.punchclock.manage'],
      hrTimeManage: data.permissions['hr.time.manage'],
      hrTargetsManage: data.permissions['hr.targets.manage'],
      settingsActivitiesManage: data.permissions['settings.activities.manage'],
      settingsRegisterManage: data.permissions['settings.register.manage'],
      settingsWebShopManage: data.permissions['settings.webshop.manage'],
      settingsOnlinePaymentManage:
        data.permissions['settings.online_payment.manage'],
      settingsShopManage: data.permissions['settings.shop.manage'],
    }

    return {
      uuid: data.uuid,
      id: data.id,
      firstName: data.first_name,
      lastName: data.last_name,
      email: data.email,
      isVisibleInCalendar: data.is_visible_in_calendar,
      isVisibleOnline: data.is_visible_online,
      isCabine: data.is_cabine,
      avatar: data.avatar,
      isActive: data.is_active,
      establishmentId: data.establishment_id,
      outOfServiceAt: data.out_of_service_at,
      startsAt: data.starts_at,
      hasToPunch: data.has_to_punch,
      permissions,
    }
  }
}

export default Transformer
